import { Component, OnInit, Input, Output, EventEmitter, OnChanges } from '@angular/core';
import { DOData, DocdefDataVM, NJDocData, NJDocDefTemplate, AutoCompleteTextBoxEntry } from "../DOData";
import { DocDefPrimLibService } from '../../doc-def-prim-lib.service';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';

@Component({
    selector: 'cy-dotext-box-autocomplete',
    templateUrl: './dotext-box-autocomplete.component.html',
    styleUrls: ['./dotext-box-autocomplete.component.css']
})
export class DotextBoxAutocompleteComponent implements OnInit, OnChanges {
    @Input() DocDefTemplate: NJDocDefTemplate;
    @Input() lstChildDocDefTemplate: Array<NJDocDefTemplate>;
    @Input() customParameters: any;
    @Input() skipPostDocDefData: any;
    @Input() lstDocData: Array<NJDocData> = new Array<NJDocData>();
    @Input() DocData: NJDocData;
    @Input() public loaderKey: string;
    @Input() isValid: boolean;
    private _isEnabled: boolean = true;
    public isDirty: boolean = false
    @Input() public set isEnabled(t: boolean) {
        this._isEnabled = t;
     }
    public get isEnabled(): boolean {
        return this._isEnabled;
    }
    @Input() isPopUpYesNo: string = "Neither";
    //@Input() public ignorLabel: boolean = false;
    //Keep API from firing if not needed.
    isLoading: boolean = false;
    //use for zip code field
    @Input() public hasEvent: boolean = false;
    public itemList: Array<AutoCompleteTextBoxEntry>;
    public filteredList: any[];
    public filteredListRefrences: any[];
    public previousKey: string;
    public currentKey: string;
    public docDefComposite: any;
    public textField: string = '';
    public flag: boolean = true;
    public keySearchFlag: boolean = false;
    public ContainsTypeSearch: boolean = false;
    StylesText: any;
    LabelStylesText: any;
    inputStyles: any;
    errorMessage: string;
    @Output() clickBut: EventEmitter<DOData> =
        new EventEmitter<DOData>();
    TextBoxStyle: any;
    TextBoxStyles: any;
    isReadOnly: boolean = false;

    modelChanged: Subject<any> = new Subject<any>();
    constructor(private data: DocDefPrimLibService) {
        this.modelChanged.pipe(
            debounceTime(2000), // wait 2000ms after the last event before emitting last event, 
                               //react only to the most recent user input after a period of inactivity
            distinctUntilChanged()) // only emit if value is different from previous value
            .subscribe((model: any) => {
                if (model.callApi) {
                    this.getListAutoCompleteData(model.searchKey);
                }
                else if(!model.callApi)
                {
                    if (this.filteredListRefrences == undefined || this.filteredListRefrences == null) {
                        this.getListAutoCompleteData(model.searchKey);
                    }
                    else {
                        //search from existing data
                        //console.log("search from existing data", model.searchKey);
                        this.getListAutoCompleteDataFromExisting(model.searchKey);
                    }
                }
            });
    }

    public initialized: boolean = false;
    public needToCallOnChanges: boolean = true;
    public clearIfNoResult: boolean = false;
    public preLoadExisting: boolean = false;
    public minimumPrefixLength: number = 0;

    ngOnInit() {
        if (this.DocData == null) {
            this.DocData = new NJDocData();
            this.DocData.docDataHdrId = -1;
            this.DocData.docDefDataRowID = 0;
            this.DocData.docDefDataRowParID = 0;
            this.DocData.docDefTemplateID = this.DocDefTemplate.docDefTemplateID;
        }
        else {
            // We try to populate existing selection
            this.textField = this.DocData.dataValue;
            this.preLoadExisting = true;
        }
        
        if (this.customParameters['MinimumPrefixLength'] != null) {
            this.minimumPrefixLength = this.customParameters['MinimumPrefixLength'];
        }

        this.initialized = true;
        if (this.needToCallOnChanges) {
            this.ngOnChanges();
            this.needToCallOnChanges = false;
        }
    }

    private getListAutoCompleteDataFromExisting(term: string) {
    
        let result = this.filteredListRefrences.filter(item => item.display.toLowerCase().includes(term.toLowerCase()));
        this.filteredList = result;
        //console.log("from getListAutoCompleteDataFromExisting",result);
        this.initialized = true;
        if (this.needToCallOnChanges) {
            this.ngOnChanges();
            this.needToCallOnChanges = false;
        }
    }
   
    private getListAutoCompleteData(term: string) {
        let lstDocData: DocdefDataVM = new DocdefDataVM();
        let txtDocData: NJDocData = new NJDocData();
        txtDocData.dataValue = term;
        txtDocData.docDefTemplateID = this.DocDefTemplate.docDefTemplateID
        lstDocData.loaderKey = this.loaderKey;
        lstDocData.docdata.push(txtDocData);
        //console.log(term);
        this.data.getAutoCompleteData(lstDocData)
            .subscribe((ret: boolean) => {
                if (ret) {
                    this.filteredList = this.data.lstAutoCompleteTextBoxEntry;
                    this.filteredListRefrences = this.data.lstAutoCompleteTextBoxEntry;
                    //console.log("getListAutoCompleteData From API call", this.filteredList);
                    
                    this.initialized = true;
                    if (this.needToCallOnChanges) {
                        this.ngOnChanges();
                        this.needToCallOnChanges = false;
                    }
                }
            }, (err: any) => console.log(err), () => {});
    }

    ngOnChanges(): void {
        // only execute on changes
        // when it's initialized
        if (this.initialized) {
            if (this.customParameters['StylesText'] != null) {
                let styles = this.data.replaceAll(this.customParameters['StylesText'], "'", '"');
                this.StylesText = JSON.parse(styles);
            }
            if (this.customParameters['LabelStylesText'] != null) {
                let styles = this.data.replaceAll(this.customParameters['LabelStylesText'], "'", '"');
                this.LabelStylesText = JSON.parse(styles);
            }
            if (this.customParameters['TextBoxStyles'] != null) {
                let styles = this.data.replaceAll(this.customParameters['TextBoxStyles'], "'", '"');
                this.TextBoxStyles = JSON.parse(styles);
            }
            this.setReadonlyStatus();
        }
        else {
            this.needToCallOnChanges = true;
        }
    }

    onInput(value): void {
        this.searchClient(value);
    }
    // Push a search term into the observable stream.  
    searchClient(term: string): void {
        //var strFirstThree = term.substring(0, 3);
        if (term.trim().length == this.minimumPrefixLength) {
            //console.log("When length is 3, called API", term);
            this.previousKey = term;
            this.flag = false;
            this.keySearchFlag = true;
            this.getListAutoCompleteData(term);
        }
        else if (term.trim().length > this.minimumPrefixLength) {
            var strFirstThree = term.substring(0, 3);
            if (this.previousKey == strFirstThree && this.keySearchFlag) {
                //no Api call, search from existing data
                //console.log("When previous and present key same - search from existing data", term);
                let obj = { callApi: false, searchKey: term }
                this.modelChanged.next(obj);
            }
            else {
                //this.currentKey = term;
                //console.log("When previous and present key are not same, called API", term);
                this.previousKey = strFirstThree;
                this.flag = false;
                this.keySearchFlag = false;
                let obj = { callApi: true, searchKey: term }
                this.modelChanged.next(obj);
            }
        }
        else if (term.length == 0) {
            // create an empty value and set it 
            this.previousKey = "";
            var selItem: AutoCompleteTextBoxEntry = new (AutoCompleteTextBoxEntry);
            selItem.display = "";
            selItem.returnArg = "";
            this.onselectClient(selItem);
        }
    }

    public curItem: any;
    onselectClient(item: any) {
        this.curItem = item;
        this.textField = item.display;
        this.flag = true;
        this.SaveValue(item);
    }

    SaveValue(selItem: AutoCompleteTextBoxEntry) {
        let lstDocData: DocdefDataVM = new DocdefDataVM();

        let retArgList = this.lstChildDocDefTemplate.filter(function (item) {
            return item.dictCustomParameters["ReturnArg"] == "True";
        });
        let docData: NJDocData = new NJDocData();
        if (retArgList.length > 0) {
            docData.dataValue = selItem.returnArg;
            docData.docDefTemplateID = retArgList[0].docDefTemplateID;
            docData.docDataHdrId = -1;
            docData.docDefDataRowID = 0;
            docData.docDefDataRowParID = 0;
        }
        lstDocData.docdata.push(docData);
        var index1 = this.lstDocData.findIndex(x => x.docDefTemplateID == docData.docDefTemplateID);
        if(index1 >=0){
            this.lstDocData[index1].dataValue = docData.dataValue;
        }else{
            this.lstDocData.push(docData);
        }

        let displayList = this.lstChildDocDefTemplate.filter(function (item) {
            return item.dictCustomParameters["DisplayAutoComplete"] == "True";
        });
        let docDataDisplay: NJDocData = new NJDocData();
        if (displayList.length > 0) {
            docDataDisplay.dataValue = selItem.display;
            docDataDisplay.docDefTemplateID = displayList[0].docDefTemplateID;
            docDataDisplay.docDataHdrId = -1;
            docDataDisplay.docDefDataRowID = 0;
            docDataDisplay.docDefDataRowParID = 0;
        }
        lstDocData.docdata.push(docDataDisplay);

        var index2 = this.lstDocData.findIndex(x => x.docDefTemplateID == docDataDisplay.docDefTemplateID);
        if(index2 >=0){
            this.lstDocData[index2].dataValue = docDataDisplay.dataValue;
        }else{
            this.lstDocData.push(docDataDisplay);
        }

        lstDocData.loaderKey = this.loaderKey;
        this.isDirty = true;
        var _this = this;

        if ((this.customParameters.skipPostDocDefData == "True") || (this.skipPostDocDefData == true)) {
            return _this.onSaveComplete();
        }
        else {
            this.data.saveDocDefData(lstDocData)
                .subscribe(function () {
                    return _this.onSaveComplete();
                }, function (error) {
                    return _this.errorMessage = error;
                });
        }        
    }

    onSaveComplete = function () {
       // console.log(this.data.postResp);

        // **********************************
        // call firing only after it's saved
        // **********************************
        this.callEvent(this.curItem.returnArg);

    }

    labelClass(): string {
        if (this.customParameters['LabelWidth'] == null) {
            if (this.customParameters['StackLabel'] == 'Yes')
                return "col-md-12 col-sm-12";
            else
                return "col-md-6 col-sm-6";
        } else {
            return this.customParameters['LabelWidth'];
        }
    }
    inputWidth(): string {
        if (this.customParameters['InputWidth'] == null) {
            return "";
        } else {
            return this.customParameters['InputWidth'];
        }
    }
    inputClass(): string {
        if (this.customParameters['InputWidth'] == null) {
            if (this.customParameters['FormGroupItem'] == null) {

                return "form-control col-md-6 col-sm-6";
            }
            else {
                return "form-control";
            }
        } else {
            return "form-control " + this.customParameters['InputWidth'];
        }
    }
    IsFormGroup() {
        if (this.customParameters['FormInline'] == 'Yes')
            return "form-inline";
        else
        if (this.customParameters['FormGroupItem'] == 'Yes')
            return "form-group flex-nowrap";
        else
            return "";
    }
    getTextStyle(): object {
        if (this.customParameters['inputStyles'] != null) {
            let styles = this.data.replaceAll(this.customParameters['inputStyles'], "'", '"');
            this.TextBoxStyle = JSON.parse(styles);
            if (this.isValid)
                if (this.isReadOnly == true) {
                    this.TextBoxStyle['background-color'] = "white";
                    return this.TextBoxStyle;
                }
                else {
                    return this.TextBoxStyle;
                }
            else {
                this.TextBoxStyle['background-color'] = "lightpink";
                return this.TextBoxStyle;
            }
        }
        else {
            if (this.isValid)
                return null
            else
                return { "background-color": "lightpink" };
        }
    }
    callEvent(selection) {
        if (this.hasEvent) {
            let DOMessage: DOData = new DOData();
            DOMessage.njDocData = this.DocData;
            if (DOMessage.njDocData == null) {
                DOMessage.njDocData = new NJDocData();
            }
            if (selection != null) {
                DOMessage.njDocData.dataValue = selection.toString();
            }
            else {
                DOMessage.njDocData.dataValue = null;
            }
            DOMessage.njDocDefTemplate = this.DocDefTemplate;
            this.clickBut.emit(DOMessage);
        }
    }

    setReadonlyStatus() {
        if (this.customParameters.isReadOnly == 'Yes')
            this.isReadOnly = true;
        //is the the required seccode in the user's credentials
        else if (this.customParameters["DisabledIfMissingSecCode"]) {
        }
        else this.isReadOnly = false;
    }
    
    ngOnDestroy() {
        this.modelChanged.unsubscribe();
    }
}


